import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useGetFiltersInfo from '../hooks/useGetFiltersInfo';
import OptionsSelector from '../ui/OptionsSelector';

const LocationFilter = ({ type }) => {
  const { t } = useTranslation('search');
  const { data, prevData, params, updateParams } = useGetFiltersInfo();

  const options = data?.locations || prevData?.locations || [];

  const onChange = (newLocations) => {
    updateParams({
      locations: newLocations,
      page: 1,
    });
  };

  return (
    <OptionsSelector
      id="location-filter"
      options={options}
      onChange={onChange}
      placeholder={t('Search')}
      type={type}
      value={params.locations}
    />
  );
};

LocationFilter.propTypes = {
  type: PropTypes.string.isRequired,
};

export default LocationFilter;
